<template>
  <v-container class="app-container--width-max">
    <BaseStepper
      v-if="isShowStepperBase"
      class="mb-1"
      :key="isQuestionSteps"
      :steps="isQuestionSteps ? questionSteps : applicationSteps"
    />
    <BaseAlert
      color="var(--orange-100)"
      class="quote-expired-message"
      :class="{ 'mt-5 mx-md-2 mx-3': isCoverTypePage || isFactFindPage }"
      v-if="isExpired"
    >
      <div class="d-flex flex-no-wrap error-message">
        <div class="mr-3">
          <v-icon color="var(--orange-500)">mdi-alert</v-icon>
        </div>
        <div>
          <span class="font-weight-bold">Sorry!</span> This quote has expired.
          Please check all the details below are accurate and submit a new
          quote.
        </div>
      </div>
    </BaseAlert>
    <QuoteErrorAlert class="mx-3 mx-xl-0" :isQuotationStage="isQuestionSteps" />
    <div
      :class="
        !isQuoteResultPage && !isCompletePage
          ? 'white rounded-lg elevation-3 mx-3 mt-3 mx-xl-0 pa-4 pa-xl-16'
          : 'mt-3 quote-result__container'
      "
    >
      <router-view />
    </div>
  </v-container>
</template>

<script>
import { applyThirdPartyId } from "@/common/utils";
import { ROUTE_NAME } from "@/constants/route.constants";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapGetters, mapState } from "vuex";
import { EventBus } from "@/common/eventbus.js";
import { handleValidationError } from "@/common/utils";
export default {
  name: "HomeB2BMainLayout",
  components: {
    BaseStepper: () => import("@/components/BaseComponents/BaseStepper.vue"),
    BaseAlert: () => import("@/components/BaseComponents/BaseAlert.vue"),
    QuoteErrorAlert: () => import("@/components/QuoteErrorAlert.vue"),
  },
  props: {
    urlParams: Object,
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["isExpired"]),
    ...mapState(QUESTIONS_MODULE, ["questionMap", "userId"]),
    currentRouteName() {
      return this.$route.name;
    },
    isShowStepperBase() {
      return ![
        ROUTE_NAME.HOME.B2B.COVER_TYPE,
        ROUTE_NAME.HOME.B2B.FACT_FIND,
        ROUTE_NAME.HOME.B2B.COMPLETE,
      ].includes(this.currentRouteName);
    },
    isQuestionSteps() {
      return [
        ROUTE_NAME.HOME.B2B.YOUR_DETAILS,
        ROUTE_NAME.HOME.B2B.PROPERTY_DETAILS,
        ROUTE_NAME.HOME.B2B.QUOTATION_RESULT,
      ].includes(this.currentRouteName);
    },
    isCoverTypePage() {
      return this.currentRouteName === ROUTE_NAME.HOME.B2B.COVER_TYPE;
    },
    isFactFindPage() {
      return this.currentRouteName === ROUTE_NAME.HOME.B2B.FACT_FIND;
    },
    isQuoteResultPage() {
      return this.currentRouteName === ROUTE_NAME.HOME.B2B.QUOTATION_RESULT;
    },
    isCompletePage() {
      return this.currentRouteName === ROUTE_NAME.HOME.B2B.COMPLETE;
    },
  },
  data() {
    return {
      questionSteps: [
        {
          stepNumber: 1,
          label: "Your details",
          routeName: ROUTE_NAME.HOME.B2B.YOUR_DETAILS,
        },
        {
          stepNumber: 2,
          label: "Property details",
          routeName: ROUTE_NAME.HOME.B2B.PROPERTY_DETAILS,
        },
        {
          stepNumber: 3,
          label: "Your quotes",
          routeName: ROUTE_NAME.HOME.B2B.QUOTATION_RESULT,
        },
      ],
      applicationSteps: [
        {
          stepNumber: 4,
          label: "Your application",
          routeName: ROUTE_NAME.HOME.B2B.APPLICATION,
        },
        {
          stepNumber: 5,
          label: "Payment",
          routeName: ROUTE_NAME.HOME.B2B.PAYMENT,
        },
        {
          stepNumber: 6,
          label: "Complete",
          routeName: ROUTE_NAME.HOME.B2B.COMPLETE,
        },
      ],
    };
  },
  async mounted() {
    try {
      applyThirdPartyId(false, this.userId);
      return;
    } catch (e) {
      console.error(e);
    }
  },
  created() {
    EventBus.$on("validation-error", handleValidationError);
  },
};
</script>

<style lang="scss" scoped>
:deep(.section-remider-text) {
  margin-bottom: 27px !important;
}
:deep(.save-exit-button) {
  color: #272727;
}
:deep(.back-btn) {
  margin-top: -33px !important;
  margin-left: -46px !important;
  margin-bottom: 25px !important;
}
@media screen and (max-width: 992px) {
  :deep(.back-btn) {
    margin-top: 7px !important;
    margin-left: -18px !important;
    margin-bottom: 10px !important;
  }
}
</style>
